import React from 'react';
import { useStore } from 'effector-react';
import type { HSPos } from '@types';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import WidgetRowTitlePos from '@components/PlayerWidgets/WidgetRowTitlePos';
import WidgetRowOffset from '@components/PlayerWidgets/WidgetRowOffset';
import { TITLE_SETTING_DEFAULT } from '../../constants';

const xyMap: Record<HSPos, { ox: number; oy: number }> = {
  bottom: { ox: 0, oy: -30 },
  top: { ox: 0, oy: 30 },
  left: { ox: 30, oy: 0 },
  right: { ox: -30, oy: 0 },
};

export function TitlePosSetting() {
  const { hotspot } = useStore($editingHotspot)!;
  const { titleSetting } = hotspot;
  const {
    edge = TITLE_SETTING_DEFAULT.edge,
    ox = TITLE_SETTING_DEFAULT.ox,
    oy = TITLE_SETTING_DEFAULT.oy,
  } = titleSetting;

  return (
    <>
      <WidgetRowTitlePos
        reversed
        value={edge}
        onChange={(val) => {
          $editingHotspotApi.update((draft) => {
            const oxy = xyMap[val];
            draft.titleSetting.edge = val;
            draft.titleSetting.ox = oxy.ox;
            draft.titleSetting.oy = oxy.oy;
          });
        }}
      />
      <WidgetRowOffset
        x={ox}
        y={oy}
        onXChange={(val) => {
          $editingHotspotApi.update((draft) => {
            draft.titleSetting.ox = val;
          });
        }}
        onYChange={(val) => {
          $editingHotspotApi.update((draft) => {
            draft.titleSetting.oy = val;
          });
        }}
      />
    </>
  );
}
